export var COMPOUND_OPERATOR_AND = 'and';
export var COMPOUND_OPERATOR_OR = 'or';